module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C283"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("BEFORE WE GO")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "P21"
  }, [_vm._v("EVER BEEN OBSESSED with something? I mean "), _c('em', [_vm._v("really")]), _vm._v(" obsessed? Ever lain awake dreaming about it: a new car perhaps, your dream house, a person? I guess we all have them, only my obsession is a little offbeat. Mine is "), _c('em', [_vm._v("plants")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("It has always been. I’ve chased plants for as long as I can remember: I’ve learned the language of them, how to read the land with them and how to speak to its people through them. Knowing plants lets you see a place in differently, read the forest’s mind, and listen to the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Once you’ve thought of something long and hard enough, you can’t unthink it. Right? Once you’ve hauled yourself up a wet mountainside in pursuit of a pitcher plant, macheted your way to that orchid, or divined the world’s largest flower in your mind’s eye, you have to do it for real, don’t you? Find them, whatever it takes. Get to know them, their haunts; bathe in their beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Well I've courted danger in pursuit of plants, crossed barbed wire to find them, gone over the cliff to admire them, fallen for them and stared into the barrel of a gun. And I've never felt so alive. Along the way, I’ve learned that you don’t "), _c('em', [_vm._v("need")]), _vm._v(" to do any of this. For as every plant enthusiast knows, it’s fulfilling to track down a striking work of nature wherever it may be – the woods, the golf course rough, even the retail park. And when you do, there’s no greater feeling on earth: it’s electrifying.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("I hold onto that electricity, and later, I transform it into colour. I conjure up my plants onto canvas, steadily bringing back to life my glorious moments with them by brush, collaging experience with imagination in my paintings. Together with my field diaries, they tell a story, one of a boy who dreamed of becoming a botanist.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Now let me share with you how I’ve scribbled and sketched my way around the world fulfilling that dream.")])]), _c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/17_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-753405be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_Before_We_Go.vue
// module id = 78
// module chunks = 0